export interface Config {
  local: boolean;
  dev: boolean;
  threeSceneUrl: string;
  sim2dUrl: string;
  sim3dUrl: string;
  isMobile: boolean;
};

// Build-time env vars are inlined by webpack's DefinePlugin only when accessed
// as literal `process.env.VUE_APP_*`. When the var is missing at build time,
// `String(process.env.X)` becomes the literal string "undefined", which then
// gets used as an iframe/window URL and resolves relative to the current page —
// loading the platform inside itself (navbar, footer, broken hound). Guard so a
// missing var surfaces loudly and yields an empty string instead of "undefined".
function requireUrl (value: string | undefined, name: string): string {
  if (!value || value === 'undefined' || value === 'null') {
    console.error(`[config] Missing build-time env var ${name}. The 3D render / race simulators will not load. Set it in .env.production and rebuild.`);
    return '';
  }
  return value;
}

export const config: Config = {
  dev: process.env.VUE_APP_DEV_FLAG === 'true',
  local: process.env.VUE_APP_LOCAL_FLAG === 'true',
  threeSceneUrl: requireUrl(process.env.VUE_APP_THREE_SCENE_URL, 'VUE_APP_THREE_SCENE_URL'),
  sim2dUrl: requireUrl(process.env.VUE_APP_SIM_2D_URL, 'VUE_APP_SIM_2D_URL'),
  sim3dUrl: requireUrl(process.env.VUE_APP_SIM_3D_URL, 'VUE_APP_SIM_3D_URL'),
  isMobile: !!navigator.userAgent.toLowerCase().match(/mobile/i)
};